__turbopack_context__.v({
  "col": "results-summary-module-scss-module__UJgBXW__col",
  "colHeading": "results-summary-module-scss-module__UJgBXW__colHeading",
  "ctaPill": "results-summary-module-scss-module__UJgBXW__ctaPill",
  "ctaRow": "results-summary-module-scss-module__UJgBXW__ctaRow",
  "docLinks": "results-summary-module-scss-module__UJgBXW__docLinks",
  "docRow": "results-summary-module-scss-module__UJgBXW__docRow",
  "eventDate": "results-summary-module-scss-module__UJgBXW__eventDate",
  "eventLinks": "results-summary-module-scss-module__UJgBXW__eventLinks",
  "eventTitle": "results-summary-module-scss-module__UJgBXW__eventTitle",
  "grid": "results-summary-module-scss-module__UJgBXW__grid",
  "linkStack": "results-summary-module-scss-module__UJgBXW__linkStack",
  "quarter": "results-summary-module-scss-module__UJgBXW__quarter",
  "quarterDetail": "results-summary-module-scss-module__UJgBXW__quarterDetail",
  "results": "results-summary-module-scss-module__UJgBXW__results",
  "rule": "results-summary-module-scss-module__UJgBXW__rule",
  "updateHighlight": "results-summary-module-scss-module__UJgBXW__updateHighlight",
});
